define(
    [
        'jquery',
        'underscore',
        'backbone',
        'assets/js/modules/product/model/attributeModel',
        'assets/js/modules/option/optionValueModel',
        'assets/js/modules/design/designModel',
        'assets/js/modules/design/designModelBuilder',
        'assets/js/modules/design/designFaceModel',
        'assets/js/modules/design/designFaceProcessModel',
        'assets/js/modules/designPreview/changeOptionsEventHandler',
        'assets/js/modules/designPreview/dvvPreviewView'
    ],
    function(
        $,
        _,
        backbone,
        AttributeModel,
        OptionValueModel,
        DesignModel,
        DesignModelBuilder,
        DesignFaceModel,
        DesignFaceProcessModel,
        ChangeOptionsEventHandler,
        DvvPreviewView
    ) {
        return _.extend(
            {
                dvvPreviewContainer: '#dvvView-container',
                init: function(productParams, designParams, designerParams) {
                    if (!DvvPreviewView.isAvailable(productParams.productType) || designParams.useSampleDesign === false) {
                        this.trigger('fail:dvv');

                        return false;
                    }

                    const _this = this;
                    this.model = DesignModelBuilder.createDesignModel(productParams, designParams);

                    this.initChangeOptionsEvents();

                    this.dvvPreview = new DvvPreviewView(
                        {
                            el: this.dvvPreviewContainer,
                            model: this.model
                        },
                        {
                            dvvUrl: designerParams.dvvUrl,
                            enlargePopup: designerParams.enlargePopup,
                            preloader: designerParams.preloader,
                            designerConfig: designerParams.designerConfig,
                            inverseFolding: false
                        }
                    );

                    this.dvvPreview
                        .on('init:dvv', function() {
                            _this.trigger('init:dvv');
                        })
                        .on('fail:load:dvv fail:init:dvv', function() {
                            _this.trigger('fail:dvv');
                        })
                        .on('ready:dvv', function() {
                            _this.trigger('ready:dvv');
                        });
                },

                initChangeOptionsEvents: function() {
                    ChangeOptionsEventHandler.init.bind(this)();
                },

                changeSubstrateColor: function(colorValue) {
                    this.dvvPreview.DVV.app.changeSubstrate({ color: colorValue });
                },

                /**
                 * @param colorValue
                 */
                setBackgroundColor: function(colorValue) {
                    console.log('Method available only for DVS products');
                },

                renderProofs: function() {
                    console.log('Method available only for DVS products');
                }
            },
            backbone.Events
        );
    }
);
